<template>
  <div class="pax-stepper">
    <span
      tabindex="-1"
      :class="['button decrease', { disabled: isDecreaseButtonDisabled }]"
      @keyup.enter="decrease"
      @click="decrease"
    >
      -
    </span>
    <span class="value">{{ value }}</span>
    <span
      tabindex="-1"
      :class="['button increase', { disabled :isIncreaseButtonDisabled }]"
      @keyup.enter="increase"
      @click="increase"
    >
      +
    </span>
  </div>
</template>

<script>
  const events = {
    SET_VALUE: 'setValue'
  }

  export default {
    props: {
      value: {
        type: Number,
        required: true
      },
      minValue: {
        type: Number,
        required: true
      },
      maxValue: {
        type: Number,
        required: true
      },
      parentCount: {
        type: Number,
        default: 1,
        required: false
      }
    },
    computed: {
      isDecreaseButtonDisabled () {
        return this.value === this.minValue
      },
      isIncreaseButtonDisabled () {
        return this.value === this.maxValue || this.value >= this.parentCount
      }
    },
    methods: {
      increase () {
        this.$emit(events.SET_VALUE, this.value + 1)
      },
      decrease () {
        this.$emit(events.SET_VALUE, this.value - 1)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .pax-stepper {
    height: 24px;
    margin-top: -2px;
    display: flex;
    flex-direction: row;
    width: 96px;

    /deep/ ::selection {
      background: inherit;
    }
  }

  .button, .value {
    width: 32px;
    color: $blue-medium;
    font-size: em(16);
    font-weight: 300;
    line-height: 19px;
    text-align: center;
    border-radius: 2px;
    padding: 2px 0;
    background-color: $gray-light-brown;

    &.disabled {
      background-color: $gray-lighter-brown;
      color: #bebebe;
      cursor: default;

      &:hover {
        background-color: $gray-lighter-brown;
        color: #bebebe;
      }
    }
  }

  .button {
    cursor: pointer;

    &:hover {
      background-color: $blue-medium;
      color: #ffffff;
    }
  }

  .value {
    color: $grey-default;
    font-size: em(16);
    line-height: 19px;
    text-align: center;
    font-weight: 400;
    margin: 0;
    background: transparent;
  }

</style>
